import NewReleaseDashboard from './new-release-dashboard';

export * from './new-release-dashboard';
export default NewReleaseDashboard;
